<!--光伏电站-气象信息-->
<template>
  <el-descriptions direction="vertical" :column="3" border>
    <el-descriptions-item
      :contentStyle="{ 'text-align': 'center', color: '#28CCCB' }"
      :labelStyle="{ 'text-align': 'center' }"
      v-for="(v, i) in METMonitorList"
      :key="i"
      :label="v.name"
      >{{ v.value }}</el-descriptions-item
    >
  </el-descriptions>
</template>

<script>
import api from "@/api";
import { ANGLEDEFAULT, WEATHERDEFAULT } from "@/assets/js/const";

export default {
  name: "MeteorologyInfo",
  data() {
    return {
      METMonitorList: [
        { name: "天气", value: "", key: "Weather" },
        { name: "温度", value: "", key: "Temperature" },
        { name: "日照强度", value: "", key: "IlluminanceLux" },
        { name: "组件温度", value: "", key: "DeviceTem" },
        { name: "气压", value: "", key: "Pressure" },
        { name: "湿度", value: "", key: "Humidity" },
        { name: "辐照", value: "", key: "Radiation" },
        { name: "风速", value: "", key: "WindSpeed" },
        { name: "风向", value: "", key: "WindDirection" },
      ],
    };
  },
  created() {
    this.getMeteorologyInfo();
  },
  methods: {
    async getMeteorologyInfo() {
      let res = await api.photovoltaicGetMeteorologyInfo({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))[
          "projects"
        ][0].projectId,
      });

      let dataArr = res.data.data;
      this.METMonitorList.map((v) => {
        v.value = dataArr[0][v.key];
        if (v.key === "Weather") {
          v.value = WEATHERDEFAULT?.[v.value] || "-";
        } else if (v.key === "WindDirection") {
          v.value = ANGLEDEFAULT?.[v.value] || "-";
        }
      });
    },
  },
};
</script>

<style scoped lang="scss"></style>
